import { cn } from "@omni/utils/styles";
import { Fragment } from "react";

import { PromotionPeriodComponent } from "@/components/Product/PromotionPeriod/promotionPeriod.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useProductPageContext } from "../../context/productPage.context";
import { PromotionEnhancer } from "./promotions.helper";

export type PromotionsProps = {
    className?: string;
};

const Promotions = ({ className }: PromotionsProps) => {
    const { t } = useGranite();
    const { product } = useProductPageContext();

    const promotions = PromotionEnhancer(
        product?.price?.promotions || [],
        product.doubleBonusPoints,
        t
    );

    if (promotions.length === 0) {
        return null;
    }

    return (
        <div className={cn("tw:mb-2", className)}>
            {promotions.map((promo, index) => (
                <Fragment key={`promo-${index}`}>
                    <div
                        className={cn(
                            "tw:flex tw:flex-row tw:items-center tw:text-white tw:rounded tw:bg-danger"
                        )}
                    >
                        <div
                            className={cn(
                                "tw:font-bold tw:uppercase tw:text-center tw:p-2"
                            )}
                        >
                            {t("productDetail.promoBanner.head")}
                        </div>
                        <div
                            className={cn(
                                "tw:grow tw:text-danger tw:rounded-r tw:p-2 tw:bg-yellow"
                            )}
                        >
                            {promo.marketingText}
                        </div>
                    </div>
                    {promo.validTo && (
                        <PromotionPeriodComponent
                            className={cn("tw:row! tw:gap-2 tw:justify-end")}
                            validFrom={promo.validFrom}
                            validTo={promo.validTo}
                            periodText={promo.periodText}
                        />
                    )}
                </Fragment>
            ))}
        </div>
    );
};

export { Promotions };
